// extracted by mini-css-extract-plugin
export var md = "_6n-4";
export var semantic = "_6n-5";
export var sm = "_6n-3";
export var text = "_6n-6";
export var toggleInput = "_6n-0";
export var toggleSwitch = "_6n-1";
export var xs = "_6n-2";